import { useProject } from "../../../contexts/project.context";
import { parseProjectMmCode } from "../utils/mmCode";

export function useStorageMmCode(): {
  mmCode: number | null;
  isProjectLoading: boolean;
} {
  const { project, loadingProject } = useProject();

  return {
    mmCode: parseProjectMmCode(project?.mmCode),
    isProjectLoading: !!loadingProject,
  };
}
